import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";
import { isFirmaAccount } from "../services/firmaSessionService";

const Sidebar = ({ layoutType }) => {
  const firmaAccount = isFirmaAccount();

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        {/* #623: a company login's product logo is not a link ("/" is a staff page: it showed the "open to SAKA staff" lock).
            WAS (every login): both logos were <Link to="/" className="logo logo-dark|logo-light">. */}
        <div className="navbar-brand-box">
          {[
            { cls: "logo-dark", lg: logoDark },
            { cls: "logo-light", lg: logoLight },
          ].map(({ cls, lg }) => {
            const icerik = (
              <>
                <span className="logo-sm">
                  <img src={logoSm} alt="" height="30" />
                </span>
                <span className="logo-lg">
                  <img src={lg} alt="" height="30" />
                </span>
              </>
            );
            return firmaAccount
              ? <span key={cls} className={`logo ${cls}`}>{icerik}</span>
              : <Link key={cls} to="/" className={`logo ${cls}`}>{icerik}</Link>;
          })}
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="bx bxs-chevrons-right"></i>
          </button>
        </div>
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
